// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.p-Widget.dialogOverlay {
  z-index: 5000;
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  font-size: var(--theia-ui-font-size1);
  padding: 2px;
}
.p-Widget.dialogOverlay .dialogBlock {
  display: flex;
  flex-direction: column;
  min-width: 400px;
  color: var(--theia-editorWidget-foreground);
  background-color: var(--theia-editorWidget-background);
  border: 1px solid var(--theia-contrastBorder);
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 0px 8px var(--theia-widget-shadow);
}
.p-Widget.dialogOverlay .dialogTitle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: var(--theia-ui-font-size1);
  background-color: var(--theia-statusBar-background);
  color: var(--theia-statusBar-foreground);
  padding: 0 calc(var(--theia-ui-padding) * 2);
  min-height: 24px;
}

.p-Widget.dialogOverlay .dialogTitle i.closeButton {
  cursor: pointer;
}

.p-Widget.dialogOverlay .dialogContent {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  padding: calc(var(--theia-ui-padding) * 2);
  white-space: pre-line;
  max-height: 70vh;
  overflow-y: auto;
}

.p-Widget.dialogOverlay .dialogControl {
  padding: calc(var(--theia-ui-padding) * 2);
  display: flex;
  flex-direction: row;
  align-content: right;
  flex-wrap: nowrap;
  justify-content: flex-end;
  min-height: 21px;
}

.p-Widget.dialogOverlay.hidden {
  display: none;
}
.p-Widget.dialogOverlay.dialogErrorMessage {
  display: none;
}
.p-Widget.dialogOverlay .error {
  color: var(--theia-inputValidation-errorForeground);
}
.p-Widget.dialogOverlay .error.main {
  color: var(--theia-inputValidation-errorForeground);
  border-color: var(--theia-inputValidation-errorBorder);
}
.p-Widget.dialogOverlay .error > .theia-button.main {
  background-color: var(--theia-inputValidation-errorBackground);
  color: var(--theia-inputValidation-errorForeground);
}
.p-Widget.dialogOverlay .error > .dialogErrorMessage {
  margin-top: calc(var(--theia-ui-padding) * 3);
  font-size: var(--theia-ui-font-size1);
  display: block;
}

.theia-dialog-node {
  line-height: var(--theia-content-line-height);
  margin-top: calc(var(--theia-ui-padding) * 1.5);
  margin-left: calc(var(--theia-ui-padding) * 2.5);
}

.theia-dialog-node-content {
  display: flex;
  align-items: center;
  margin-right: calc(var(--theia-ui-padding) * 1.5);
}

.theia-dialog-node-segment {
  flex-grow: 0;
  user-select: none;
  white-space: nowrap;
}

.theia-dialog-icon {
  align-content: center;
  margin-right: calc(var(--theia-ui-padding) * 1.5);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/dialog.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,sDAAsD;EACtD,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mDAAmD;EACnD,wCAAwC;EACxC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;EACnD,sDAAsD;AACxD;AACA;EACE,8DAA8D;EAC9D,mDAAmD;AACrD;AACA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.p-Widget.dialogOverlay {\n  z-index: 5000;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.3);\n  font-size: var(--theia-ui-font-size1);\n  padding: 2px;\n}\n.p-Widget.dialogOverlay .dialogBlock {\n  display: flex;\n  flex-direction: column;\n  min-width: 400px;\n  color: var(--theia-editorWidget-foreground);\n  background-color: var(--theia-editorWidget-background);\n  border: 1px solid var(--theia-contrastBorder);\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0 0px 8px var(--theia-widget-shadow);\n}\n.p-Widget.dialogOverlay .dialogTitle {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n  font-size: var(--theia-ui-font-size1);\n  background-color: var(--theia-statusBar-background);\n  color: var(--theia-statusBar-foreground);\n  padding: 0 calc(var(--theia-ui-padding) * 2);\n  min-height: 24px;\n}\n\n.p-Widget.dialogOverlay .dialogTitle i.closeButton {\n  cursor: pointer;\n}\n\n.p-Widget.dialogOverlay .dialogContent {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  position: relative;\n  padding: calc(var(--theia-ui-padding) * 2);\n  white-space: pre-line;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.p-Widget.dialogOverlay .dialogControl {\n  padding: calc(var(--theia-ui-padding) * 2);\n  display: flex;\n  flex-direction: row;\n  align-content: right;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  min-height: 21px;\n}\n\n.p-Widget.dialogOverlay.hidden {\n  display: none;\n}\n.p-Widget.dialogOverlay.dialogErrorMessage {\n  display: none;\n}\n.p-Widget.dialogOverlay .error {\n  color: var(--theia-inputValidation-errorForeground);\n}\n.p-Widget.dialogOverlay .error.main {\n  color: var(--theia-inputValidation-errorForeground);\n  border-color: var(--theia-inputValidation-errorBorder);\n}\n.p-Widget.dialogOverlay .error > .theia-button.main {\n  background-color: var(--theia-inputValidation-errorBackground);\n  color: var(--theia-inputValidation-errorForeground);\n}\n.p-Widget.dialogOverlay .error > .dialogErrorMessage {\n  margin-top: calc(var(--theia-ui-padding) * 3);\n  font-size: var(--theia-ui-font-size1);\n  display: block;\n}\n\n.theia-dialog-node {\n  line-height: var(--theia-content-line-height);\n  margin-top: calc(var(--theia-ui-padding) * 1.5);\n  margin-left: calc(var(--theia-ui-padding) * 2.5);\n}\n\n.theia-dialog-node-content {\n  display: flex;\n  align-items: center;\n  margin-right: calc(var(--theia-ui-padding) * 1.5);\n}\n\n.theia-dialog-node-segment {\n  flex-grow: 0;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.theia-dialog-icon {\n  align-content: center;\n  margin-right: calc(var(--theia-ui-padding) * 1.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
